import dayjs from 'dayjs';
import { FACEBOOK_CLICK_ID_NAME, PARAMS_EXPIRY_DAYS } from '../constants';
import { getFacebookClickIdFromURL } from './getFacebookClickIdFromURL';

export const setFacebookClickIdToCookie = (): void => {
  const facebookClickId = getFacebookClickIdFromURL();

  if (facebookClickId) {
    const expireDate = dayjs().add(PARAMS_EXPIRY_DAYS, 'day').toDate();

    document.cookie = `${FACEBOOK_CLICK_ID_NAME}=${facebookClickId}; expires=${expireDate.toUTCString()}; path=/; SameSite=Lax;`;
  }
};
